/**
 * Caret Up Icon - Upward-pointing arrow for collapsible content
 *
 * Design: 16x16 caret pointing up
 * Usage: Collapse buttons, dropdown indicators when expanded
 * Color: Inherits from parent (uses currentColor)
 */

export const CaretUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.104898 11.8611C0.244892 11.9951 0.470881 11.996 0.611875 11.8611L7.9805 4.8267L15.3882 11.9003C15.5291 12.0334 15.7551 12.0334 15.8951 11.8994C16.0351 11.7644 16.0351 11.5481 15.8941 11.4142L8.27349 4.1386C8.26549 4.1309 8.25249 4.1338 8.24449 4.1271C8.23749 4.1194 8.24049 4.1079 8.23349 4.1012C8.0935 3.9672 7.86651 3.9663 7.72651 4.1012L0.10587 11.3768C-0.035124 11.5099 -0.035124 11.7271 0.104898 11.8611Z"
      fill="currentColor"
    />
  </svg>
);
